import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { zodBrandedString } from '../../utils';
import { DateString, NonNegativeMonetaryValue } from '../fields';

export const GenerateManualStatementRow = z.object({
  loanId: zodBrandedString<LosId>(),
  statementDueDate: DateString,
  principalBilled: NonNegativeMonetaryValue,
  interestBilled: NonNegativeMonetaryValue,
  escrowBilled: NonNegativeMonetaryValue,
});
export type GenerateManualStatementRow = z.infer<typeof GenerateManualStatementRow>;

export const GENERATE_MANUAL_STATEMENT_ROW_REQUIRED_FIELDS = Object.keys(GenerateManualStatementRow.shape).filter(
  (key) => !GenerateManualStatementRow.shape[key as keyof typeof GenerateManualStatementRow.shape].isOptional(),
);
